import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { receiveUserProfile } from '../actions';
import LoggedUserButtons from './LoggedUserButtons';

class AdminNavigationBar extends React.Component {
    componentDidMount() {
      const { dispatch, user } = this.props;
      if (!user) {
        fetch(`/api/userProfile`, { credentials: 'same-origin' }).then(response => {
          if (response.status === 200) {
            response.json().then(data => dispatch(receiveUserProfile(data)));
          } else {
            location.href = '#/login';
          }
        });
      }
    }

    render() {
      const { user } = this.props;
      if (user) {
        return (
            <div className="mb-4">
                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <img src="/static/pzbs_logo.png" height="50" className="mr-3" />
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                        <div className="navbar-nav text-center">
                            <Link className="nav-item nav-link active" to="/admin">Moje turnieje</Link>
                        </div>
                        {
                        user.userRole === 'ROOT' ? (
                                <div className="navbar-nav text-center">
                                    <Link className="nav-item nav-link active" to="/users">Użytkownicy</Link>
                                </div>
                        ) : ''
                    }
                    </div>
                    <div>
                        <LoggedUserButtons />
                    </div>
                </nav>
            </div>
        );
      } else {
          return (<div></div>);
      }
    }
}

function mapStateToProps(state) {
    return { user: state.user };
}
  
export default connect(mapStateToProps)(AdminNavigationBar);



// WEBPACK FOOTER //
// ./components/AdminNavigationBar.js